import { AuditMatch } from '@mi-front/core';
import { defineMessage } from 'react-intl';
import { useAuditAudioTranscription } from './useAuditAudioTranscription';
import { VerifyMatchTextSection } from './VerifyMatchTextSection';

const transcriptionTitleMessage = defineMessage({
  id: 'audit.verifyMatch.transcriptionTitle',
  defaultMessage: 'Transcripción de media',
});

const noTranscriptionMessage = defineMessage({
  id: 'audit.verifyMatch.noTranscription',
  defaultMessage: 'No hay transcripción disponible para esta media.',
});

export interface VerifyMatchSpotTranscriptionProps {
  match: AuditMatch;
  stationId: string;
  open: boolean;
}

/**
 * Spot creative transcription section (fetched or preloaded from the reference audio).
 */
export function VerifyMatchSpotTranscription({
  match,
  stationId,
  open,
}: VerifyMatchSpotTranscriptionProps) {
  const customId = match.audio?.customId;
  const preloaded = match.audio?.transcription;

  const { data, isLoading, isError } = useAuditAudioTranscription(
    stationId,
    customId,
    preloaded,
    open,
  );

  const content = preloaded?.content ?? data?.content;

  return (
    <VerifyMatchTextSection
      title={transcriptionTitleMessage}
      emptyMessage={noTranscriptionMessage}
      content={content}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
